import React from 'react';
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button';
import { useEffect } from 'react'
import { Separator } from '@/components/ui/separator';


function Colofon() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className='mx-auto max-w-prose my-12 font-gotham text-medium text-center px-8'>
        {/*       <tag className="font-gotham text-background bg-black rounded-full px-4 py-2 text-bold">Jaar 1</tag> */}
        <h1 className='my-6'>Colophon</h1>
        <p className='my-6'>With thanks to all partners and contributors who helped make this project possible.</p>

        {/* Section: Van Gogh Museum */}
        <p className='my-6'>
          <span className='font-bold'>Project</span> <br></br>
          © Van Gogh Museum <br></br>
          Project lead: Manon Moussa-Roodenburg <br></br>
          Education: Harma van Uffelen <br></br>
        </p>


                        {/* Section: Blooming */}
                        <p className='my-6'>
          <span className='font-bold'>Locations</span> <br></br>

          <span className='font-bold'>South East: </span><a
    href="https://www.stichtingbng.nl/"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-70 hover:text-black"
  >
    Buurvrouwennetwerk Gaasperdam
  </a><br></br>

  <span className='font-bold'>North: </span><a
    href="https://stichtingmalak.com/"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-70 hover:text-black"
  >
    Stichting Malak
  </a><br></br>

  <span className='font-bold'>East: </span><a
    href="https://stichtingprachtvrouw.nl/"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-70 hover:text-black"
  >
    Stichting Prachtvrouw
  </a><br></br>
  
  <span className='font-bold'>West: </span><a
    href="https://www.vrouwenvooruit.nl/"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-70 hover:text-black"
  >
   Vrouwen Vooruit
  </a><br></br>

  <span className='font-bold'>New West: </span><a
    href="https://vrouwenvaart.nl/"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-70 hover:text-black"
  >
    Vrouw en Vaart
  </a><br></br><br></br>

  <a
    href="https://oba.nl/nl"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-70 hover:text-black"
  >
    Openbare Bibliotheek Amsterdam
  </a><br></br>
  <a
    href="https://dezwijger.nl/"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-70 hover:text-black"
  >
    Pakhuis de Zwijger
  </a><br></br>
  <a
    href="https://www.mandarinoriental.com/en/amsterdam/conservatorium"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-70 hover:text-black"
  >
    Conservatorium Hotel
  </a><br></br>

        </p>

        {/* Section: Cypher Studio */}
        <p className='my-6'>
          <span className='font-bold'>Design & development</span> <br></br>
          <a
    href="https://cypherstudio.org"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-70 hover:text-black"
  >
    © Cypher Studio
  </a><br></br>
          Gianni Antonia & Mara Albanese<br></br>
        </p>


                {/* Section: Marielle */}
                <p className='my-6'>
          <span className='font-bold'>Visual identity</span> <br></br>
          <a
    href="https://www.studiosap.com/"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-70 hover:text-black"
  >
    © Studio Sap
  </a><br></br>
  Mariëlle Tolenaar
        </p>

                        {/* Section: Blooming */}
                        <p className='my-6'>
          <span className='font-bold'>Fotography</span> <br></br>
          <a
    href="https://bloomingmoonstudio.nl"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-70 hover:text-black"
  >
    © Blooming Moon Studio
  </a><br></br>
        </p>

        <h1 className='mt-24'>Partners</h1>
        <div className='grid md:grid-cols-5 grid-cols-2   mx-auto gap-2 gap-y-12 my-12 items-start '>

          {/* LOGOS */}
        <a
    href="https://vangoghmuseum.nl"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-90"
  >
      <img
          src='/assets/logos/Van-Gogh-museum-logo.jpg'
          alt="Footer Banner"
          className="w-full object-contain h-24"
        /></a>

        {/* 2 */}
        <a
    href="https://www.samensterkmetwerk.nl"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-90"
  >
      <img
          src='/assets/logos/cropped-cropped-Alliantie_Logo_CMYK.png'
          alt="Footer Banner"
          className="w-full h-24 object-contain"
        /></a>

                                {/* 5 */}
                                <a
    href="https://www.vanlanschotkempen.com/"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-90"
  >
      <img
          src='/assets/logos/Van_Lanschot_Kempen_logo.svg.png'
          alt="Footer Banner"
          className="h-24 w-full object-contain "
        /></a>

                {/* 3 */}
                <a
    href="https://cultuurparticipatie.nl/"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-90"
  >
      <img
          src='/assets/logos/2023-09-25-FCP-logopakket-02.png'
          alt="Footer Banner"
          className="w-full h-24 object-contain"
        /></a>


                {/* 4 */}
                <a
    href="https://www.amsterdam.nl/"
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-90"
  >
      <img
          src='/assets/logos/Logo_of_Gemeente_Amsterdam.svg.png'
          alt="Footer Banner"
          className="w-full h-24 object-contain"
        /></a>

        

      </div>
      </div>


    </>
  );
}

export default Colofon;